// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var ImportEnrichmentRuleTypes$ReactHooksTemplate = require("./ImportEnrichmentRuleTypes.res.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");
var ImportEnrichmentRuleValidation$ReactHooksTemplate = require("./ImportEnrichmentRuleValidation.res.js");

function pathSet(param) {
  
}

function addPath(set, path) {
  if (path.trim() === "") {
    return set;
  } else {
    return Belt_SetString.add(set, path);
  }
}

function templatePaths(template) {
  var re = new RegExp("\\$\\{([^}]+)\\}", "g");
  var paths = {
    contents: /* [] */0
  };
  var loop = function (_param) {
    while(true) {
      var result = re.exec(template);
      if (result === null) {
        return ;
      }
      var pathNullable = Belt_Array.get(result, 1);
      if (pathNullable !== undefined) {
        var pathNullable$1 = Caml_option.valFromOption(pathNullable);
        if (!(pathNullable$1 == null)) {
          paths.contents = {
            hd: pathNullable$1,
            tl: paths.contents
          };
        }
        
      }
      _param = undefined;
      continue ;
    };
  };
  loop();
  return paths.contents;
}

function actionTargetPath(row) {
  var match = row.targetKind;
  if (match === "more_details") {
    return "more_details." + row.targetField;
  } else {
    return "customer_details_data." + row.targetField;
  }
}

function collectActionPaths(row, set) {
  var match = row.valueType;
  var set$1;
  switch (match) {
    case "Literal" :
        set$1 = set;
        break;
    case "CopyPath" :
        set$1 = addPath(set, row.copyPath);
        break;
    case "LookupTable" :
        set$1 = addPath(set, row.lookupPath);
        break;
    case "RegexCapture" :
        set$1 = addPath(set, row.regexPath);
        break;
    case "DateDiffDays" :
        set$1 = addPath(addPath(set, row.fromPath), row.toPath);
        break;
    case "Template" :
        var next = {
          contents: set
        };
        Belt_List.forEach(templatePaths(row.templateText), (function (path) {
                next.contents = addPath(next.contents, path);
              }));
        set$1 = next.contents;
        break;
    
  }
  if (row.onlyIfBlank) {
    return addPath(set$1, actionTargetPath(row));
  } else {
    return set$1;
  }
}

function collectPaths(conditions, actions) {
  var set = Belt_List.reduce(Belt_List.keep(conditions, ImportEnrichmentRuleValidation$ReactHooksTemplate.isConditionValid), undefined, (function (acc, row) {
          return addPath(acc, row.path);
        }));
  return Belt_List.reduce(actions, set, (function (acc, row) {
                return collectActionPaths(row, acc);
              }));
}

function labelForPath(fieldOptions, path) {
  var field = ImportEnrichmentFieldOptions$ReactHooksTemplate.findByPath(fieldOptions, path);
  if (field !== undefined) {
    return field.label;
  } else {
    return Js_string.replace(Belt_Array.sliceToEnd(Js_string.split(".", path), 1).join(" "), "_", " ");
  }
}

function bucketForPath(path) {
  if (Js_string.startsWith("context.", path)) {
    return "Context";
  } else if (Js_string.startsWith("more_details.", path)) {
    return "Record details";
  } else {
    return "Customer data";
  }
}

function bucketSortOrder(bucket) {
  switch (bucket) {
    case "Context" :
        return 2;
    case "Customer data" :
        return 0;
    case "Record details" :
        return 1;
    default:
      return 3;
  }
}

function placeholderForPath(conditions, path) {
  var condition = Belt_List.getBy(conditions, (function (row) {
          if (row.path === path) {
            return ImportEnrichmentRuleValidation$ReactHooksTemplate.isConditionValid(row);
          } else {
            return false;
          }
        }));
  if (condition === undefined) {
    return "Enter a sample value";
  }
  var match = condition.op;
  switch (match) {
    case "blank" :
    case "present" :
        return "Leave empty to test blank/present";
    default:
      if (condition.value !== "") {
        return "e.g. a value that " + ImportEnrichmentRuleTypes$ReactHooksTemplate.opLabel(condition.op) + " \"" + condition.value + "\"";
      } else {
        return "Enter a sample value";
      }
  }
}

function buildFieldInputs(conditions, actions, fieldOptions) {
  return Belt_List.sort(Belt_List.map(Belt_List.sort(Belt_SetString.toList(collectPaths(conditions, actions)), $$String.compare), (function (path) {
                    return {
                            path: path,
                            label: labelForPath(fieldOptions, path),
                            bucket: bucketForPath(path),
                            placeholder: placeholderForPath(conditions, path)
                          };
                  })), (function (a, b) {
                var order = Caml.int_compare(bucketSortOrder(a.bucket), bucketSortOrder(b.bucket));
                if (order !== 0) {
                  return order;
                } else {
                  return $$String.compare(a.label.toLowerCase(), b.label.toLowerCase());
                }
              }));
}

function groupFieldInputs(inputs) {
  var order = {
    contents: /* [] */0
  };
  var byBucket = {};
  Belt_List.forEach(inputs, (function (input) {
          var rows = Js_dict.get(byBucket, input.bucket);
          if (rows !== undefined) {
            byBucket[input.bucket] = {
              hd: input,
              tl: rows
            };
          } else {
            order.contents = {
              hd: input.bucket,
              tl: order.contents
            };
            byBucket[input.bucket] = {
              hd: input,
              tl: /* [] */0
            };
          }
        }));
  return Belt_List.map(Belt_List.sort(order.contents, (function (left, right) {
                    return Caml.int_compare(bucketSortOrder(left), bucketSortOrder(right));
                  })), (function (bucket) {
                return [
                        bucket,
                        Belt_Option.getWithDefault(Js_dict.get(byBucket, bucket), /* [] */0)
                      ];
              }));
}

function fst(a, param) {
  return a;
}

exports.pathSet = pathSet;
exports.addPath = addPath;
exports.templatePaths = templatePaths;
exports.actionTargetPath = actionTargetPath;
exports.collectActionPaths = collectActionPaths;
exports.collectPaths = collectPaths;
exports.labelForPath = labelForPath;
exports.bucketForPath = bucketForPath;
exports.bucketSortOrder = bucketSortOrder;
exports.placeholderForPath = placeholderForPath;
exports.buildFieldInputs = buildFieldInputs;
exports.groupFieldInputs = groupFieldInputs;
exports.fst = fst;
/* ImportEnrichmentRuleTypes-ReactHooksTemplate Not a pure module */
